import {
  FiArrowRight,
  FiBarChart2,
  FiCamera,
  FiInstagram,
} from "react-icons/fi";

const services = [
  {
    icon: <FiBarChart2 size={34} />,
    title: "Digital Marketing",
    projects: "117 Projects",
  },
  {
    icon: <FiInstagram size={34} />,
    title: "Social Media Management",
    projects: "84 Projects",
  },
  {
    icon: <FiCamera size={34} />,
    title: "Photography & Video",
    projects: "32 Projects",
  },
];

const stats = [
  {
    number: "250+",
    title: "Projects Completed",
  },
  {
    number: "100+",
    title: "Community Network",
  },
  {
    number: "30+",
    title: "Contract Remote",
  },
  {
    number: "10+",
    title: "Years Experience",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="py-24"
    >
      <div className="max-w-7xl mx-auto px-6">

        <div className="grid lg:grid-cols-2 gap-20">

          {/* Left */}

          <div>

            <h2 className="text-5xl font-black leading-tight mb-8">
              What Can I Do
              <br />
              For Your Needs
            </h2>

            <p className="text-gray-500 leading-8 mb-12">
              It is easier to entrust the work to experts
              because they are able to provide the best
              results with reliable quality. Every project
              is crafted with strategy, creativity and
              attention to detail.
            </p>

            <div className="grid grid-cols-2 gap-10">

              {stats.map((item, index) => (
                <div key={index}>

                  <h3 className="text-4xl font-bold">
                    {item.number}
                  </h3>

                  <p className="text-gray-500 mt-2">
                    {item.title}
                  </p>

                </div>
              ))}

            </div>

          </div>

          {/* Right */}

          <div className="space-y-10">

            {services.map((service, index) => (
              <div
                key={index}
                className="group border-b border-gray-300 pb-8 flex justify-between items-center hover:border-red-500 transition"
              >
                <div className="flex gap-6 items-center">

                  <div className="w-16 h-16 rounded-xl border border-red-200 text-red-500 flex items-center justify-center group-hover:bg-red-500 group-hover:text-white transition">

                    {service.icon}

                  </div>

                  <div>

                    <h3 className="text-2xl font-bold mb-2">
                      {service.title}
                    </h3>

                    <p className="text-gray-500">
                      {service.projects}
                    </p>

                  </div>

                </div>

                <button className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center group-hover:bg-red-500 group-hover:text-white group-hover:border-red-500 transition">

                  <FiArrowRight />

                </button>

              </div>
            ))}

          </div>

        </div>

      </div>
    </section>
  );
}